import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import styleClasses from "./career.module.scss";
import { REACT_APP_CLOUD_FRONT } from "../../constants";
import useCheckMobileScreen from "../../hooks/useCheckMobileScreen";
export interface OurBenefits {
  image: any;
  title: string;
  content: string;
  isShowTeamTips: boolean;
}
const OurBenefits =  ({ heading, description, className, isShowTeamTips }) => {
  const intervalValue = 333;
  const isItMobile = useCheckMobileScreen();
  const ourBenefitsArray= [
    {
      image: [
        "images/career-overview/teamtips.svg",
        "images/career-overview/teamTips1.svg",
        "images/career-overview/teamTips2.svg",
      ],
      title: "Team Tips",
      content:
        "Every team member gets a share of the tips earned while working.",
    },
    {
      image: [
        "images/career-overview/sundaysoff.svg",
        "images/career-overview/sundaysoff1.svg",
        "images/career-overview/sundaysoff2.svg",
      ],
      title: "sundays off",
      content:
        "Our restaurants are closed every Sunday so our teams can recharge.",
    },
    {
      image: [
        "images/career-overview/careerdevelopment.svg",
        "images/career-overview/careerDevelopment1.svg",
        "images/career-overview/careerDevelopment2.svg",
      ],
      title: "career development",
      content:
        "Raises based on training and opportunities to grow your career.",
    },
    {
      image: [
        "images/career-overview/freefood.svg",
        "images/career-overview/freefood1.svg",
        "images/career-overview/freefood2.svg",
      ],
      title: "free food",
      content: "Get your fill of house-made food every shift.",
    },
    {
      image: [
        "images/career-overview/matching.svg",
        "images/career-overview/matching1.svg",
        "images/career-overview/matching2.svg",
      ],
      title: "401k matching",
      content: "Team Members can invest in their future with our 401k plan.",
    },
    {
      image: [
        "images/career-overview/holidayclosure.svg",
        "images/career-overview/holidayclosure1.svg",
        "images/career-overview/holidayclosure2.svg",
      ],
      title: "holiday closures",
      content:
        "Celebrate holidays without having to worry about getting called in!",
    },
  ];

  type ImageState = { activeImage: number | null; value: number };
  const [imageState, setImageState] = useState<ImageState>({
    activeImage: null,
    value: 0,
  });
  const handleMouseEnter = (index) => {
    let animationCompleted = false;
    const interval = setInterval(() => {
      setImageState((prevState) => {
        if (!animationCompleted && prevState.value < 2) {
          return { activeImage: index, value: prevState.value + 1 };
        }
        return prevState;
      });
    }, intervalValue);

    setTimeout(() => {
      animationCompleted = true;
      setImageState({ activeImage: index, value: 2 });
      clearInterval(interval);
    }, 1000);
  };
  const handleMouseLeave = () => {
    setImageState({ activeImage: null, value: 0 });
  };

  const filterBenifitsArray = isShowTeamTips
    ? ourBenefitsArray
    : ourBenefitsArray.filter((benifit) => benifit.title !== "Team Tips");

  return (
    <>
      <div className={`${styleClasses.ourBenefitsWrapper} ${className}`}>
        <div className="container">
          <Row>
            {/* <Col lg="9" md="9" className="m-auto">
              <h2 className="f-s55 f-w7 font-Visby-cf clr-dark-grey text-uppercase lh-normal f-sm-s24">
                {heading}
              </h2>
              {description && (
                <p className="pt-4 clr-dark-grey f-s24 f-w4 f-sm-s14 mb-0">
                  We’re dedicated to hiring passionate, enthusiastic team
                  members, creating an enjoyable environment and providing
                  benefits you’ll value throughout your career.
                </p>
              )}
            </Col> */}
          </Row>
          <Row>
            <Col lg="10" md="10"
              className={`m-auto`}
            >
              <div className={`${styleClasses.ourBenefits}`}>
                <ul
                className="justify-content-center"
                 
                >
                  {filterBenifitsArray.map((item, i) => {
                    return (
                      <li
                        key={i}
                        className="d-flex flex-column justify-content-center align-items-center"
                        style={{maxWidth: !isShowTeamTips && i >2  && !isItMobile ?  '33.33%': '50%'}}
                      >
                        <img
                          src={
                            i == imageState.activeImage
                              ? `${REACT_APP_CLOUD_FRONT}/${
                                  item.image[imageState.value]
                                }`
                              : `${REACT_APP_CLOUD_FRONT}/${item.image[0]}`
                          }
                          className={`${styleClasses.benefitsImgs} img-fluid`}
                          style={{maxWidth: '140px'}}
                          alt={item.title}
                          onMouseEnter={() => handleMouseEnter(i)}
                          onMouseLeave={handleMouseLeave}
                        />
                        <h2
                          className={`${styleClasses.benefitTitle} f-s30 f-w7 clr-dark-grey font-Trade-bold text-capitalize pt-3 f-sm-s20 text-nowrap mb-3 `}
                        >
                          {item.title}
                        </h2>
                        <p
                          className={`${styleClasses.benefitText} f-s18 f-w4 clr-dark-grey font-Trade-regular mb-0 f-sm-s14 px-0 px-md-2 lh-normal`}
                        >
                          {item.content}
                        </p>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default OurBenefits;
